/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
    CheckExceptionModelDataPageDto,
    ErrorHttpContentDto,
    SearchCheckExceptionModelDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class CheckExceptionClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags CheckException
   * @name CheckExceptionSearchCheckExceptions
   * @summary Searches for check exceptions that meet the criteria of the request.
   * @request POST:/CheckException/Search
   */
  checkExceptionSearchCheckExceptions = (
    data: SearchCheckExceptionModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<CheckExceptionModelDataPageDto, ErrorHttpContentDto>({
      path: `/CheckException/Search`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CheckException
   * @name CheckExceptionGetAttachment
   * @summary Retrieves an attached file for the specified check exception.
   * @request GET:/CheckException/{arpExceptionDetailUniqueId}/Attachment
   */
  checkExceptionGetAttachment = (
    arpExceptionDetailUniqueId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<any, ErrorHttpContentDto>({
      path: `/CheckException/${arpExceptionDetailUniqueId}/Attachment`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CheckException
   * @name CheckExceptionDownloadCheckExceptionsPdf
   * @summary Searches and downloads a PDF for check exceptions that meet the criteria of the request.
   * @request POST:/CheckException/Download/Pdf
   */
  checkExceptionDownloadCheckExceptionsPdf = (
    data: SearchCheckExceptionModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<File, ErrorHttpContentDto>({
      path: `/CheckException/Download/Pdf`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CheckException
   * @name CheckExceptionDownloadCheckExceptionsCsv
   * @summary Searches and downloads a CSV for check exceptions that meet the criteria of the request.
   * @request POST:/CheckException/Download/Csv
   */
  checkExceptionDownloadCheckExceptionsCsv = (
    data: SearchCheckExceptionModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<File, ErrorHttpContentDto>({
      path: `/CheckException/Download/Csv`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
